import { apiService } from '@/services/api.service';
import type { KnownServer } from './profiler.servers';
import type { EventList, PeriodHours, Series, ServerDetail, ServerList } from './profiler.types';

// ============================================================
// Profileur : un appel par route de lecture du module « profiler »
// ============================================================
// Tout passe par la passerelle du panel (session du panel, en-têtes X-Project et X-Game-Group), jamais
// par le CICD : ces mesures vivent dans le satellite du projet, comme les rapports de la page Crashs.
// `group` impose le groupe de jeu de l'appel (Nova, Iris) ; null pour un projet sans groupes.
// Lecture seule : l'ingestion vient du mod compagnon et ne passe pas par le panel.
// ============================================================

type Res<T> = Promise<{ data?: T; error?: string; status?: number }>;

const enc = encodeURIComponent;

export const listServers = (group: string | null): Res<ServerList> => apiService.profilerRequest<ServerList>('', group);

export const getServer = (key: string, group: string | null): Res<ServerDetail> =>
  apiService.profilerRequest<ServerDetail>(`/${enc(key)}`, group);

export const getSeries = (key: string, level: string | null, hours: PeriodHours, group: string | null): Res<Series> =>
  apiService.profilerRequest<Series>(`/${enc(key)}/series?hours=${hours}${level ? `&level=${enc(level)}` : ''}`, group);

export const getEvents = (key: string, level: string | null, limit: number, group: string | null): Res<EventList> =>
  apiService.profilerRequest<EventList>(`/${enc(key)}/events?limit=${limit}${level ? `&level=${enc(level)}` : ''}`, group);

/** Serveurs de la Console (Pterodactyl) du groupe : pour repérer ceux qui n'envoient aucune mesure. */
export async function listKnownServers(group: string | null): Promise<KnownServer[] | null> {
  const res = await apiService.profilerKnownServers(group);
  return res.data?.servers ?? null;
}
